export default __webpack_public_path__ + "static/media/employee_directory.ae42229c.png";